import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgSupportCenterGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02 32.333 8 13.426c0-.645.25-1.252.703-1.713A2.404 2.404 0 0 1 10.407 11h18.897a2.418 2.418 0 0 1 2.416 2.416v7.567h-1.204v-7.567c0-.664-.539-1.213-1.212-1.213H10.415c-.327 0-.625.126-.857.357-.23.23-.356.53-.356.856l.01 16.914 5.69-3.003h8.894v1.203h-8.596l-7.182 3.803Zm31.42 1.424-3.667-3.668a5.537 5.537 0 0 0-.732-6.238 5.552 5.552 0 0 0-7.836-.52 5.55 5.55 0 0 0-.52 7.837 5.552 5.552 0 0 0 4.178 1.896 5.55 5.55 0 0 0 2.31-.53l3.735 3.736c.386.375.877.568 1.358.568.452 0 .895-.164 1.232-.501.347-.347.52-.809.5-1.31a1.876 1.876 0 0 0-.558-1.27ZM27.6 30.378a4.297 4.297 0 0 1-1.069-3.148 4.31 4.31 0 0 1 1.473-2.984 4.355 4.355 0 0 1 6.142.404c1.578 1.8 1.395 4.554-.405 6.142a4.35 4.35 0 0 1-2.868 1.078 4.368 4.368 0 0 1-3.273-1.492ZM38.66 35.5c-.22.222-.625.193-.885-.077l-3.533-3.532.03-.021.066-.044c.064-.043.129-.086.193-.138.202-.183.375-.385.548-.587l3.514 3.514a.745.745 0 0 1 .221.481.602.602 0 0 1-.154.404ZM15.817 20.088a.895.895 0 1 1-1.79 0 .895.895 0 0 1 1.79 0Zm3.995.895a.895.895 0 1 0 0-1.79.895.895 0 0 0 0 1.79Zm5.785-.895a.895.895 0 1 1-1.79 0 .895.895 0 0 1 1.79 0Z",
    fill: "currentColor"
  }));
}

export { SvgSupportCenterGlyph as default };
